import Axios from 'axios'

Axios.defaults.baseURL = 'https://viteri-api.ceslyweb.com'
